import { render } from "./NotificationBar.vue?vue&type=template&id=315d53fd&scoped=true&ts=true"
import script from "./NotificationBar.vue?vue&type=script&lang=ts"
export * from "./NotificationBar.vue?vue&type=script&lang=ts"

import "./NotificationBar.vue?vue&type=style&index=0&id=315d53fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315d53fd"]])

export default __exports__